import SegurancaApiInterceptor from '@finx/web-repository/src/apis/Seguranca/SegurancaApiInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const api = new SegurancaApiInterceptor()
const factory = new FactoryResponse()

export default {
  async getByLogin(login: string) {
    const result = await api.getAllowAnonymous(`usuarios/login/${login}`)
    return factory.build(result)
  },
}
